import StorefrontIcon from "@mui/icons-material/Storefront";
import { Chip, Stack, Typography } from "@mui/material";
import { useTripTags } from "../../admin/dictionaries/useTripTags";
import { useTagParams } from "./useTagParams";

interface PopularFiltersProps {
  ecommerceOnly: boolean;
  toggleEcommerceOnly: () => void;
}

const PopularFilters = ({ ecommerceOnly, toggleEcommerceOnly }: PopularFiltersProps) => {
  const { tags: selectedTags, setTags } = useTagParams();
  const { tags } = useTripTags();

  const popularTags = tags?.filter((tag) => tag.isPopular) ?? [];

  const isTagActive = (category: string, value: string) =>
    selectedTags.some((tag) => tag.category === category && tag.value === value);

  const toggleTag = (category: string, value: string) => {
    const isActive = isTagActive(category, value);

    if (isActive) {
      setTags(selectedTags.filter((tag) => !(tag.category === category && tag.value === value)));
    } else {
      setTags([...selectedTags, { category, value }]);
    }
  };

  return (
    <Stack
      direction="row"
      spacing={1}
      useFlexGap
      sx={{
        mt: 1.5,
        pt: 1.5,
        borderTop: "1px solid rgba(0,0,0,0.06)",
        alignItems: "center",
        flexWrap: "wrap",
      }}
    >
      <Typography
        variant="caption"
        color="textSecondary"
        sx={{
          textTransform: "uppercase",
          fontWeight: 700,
          letterSpacing: 0.4,
          mr: 0.5,
        }}
      >
        Najczęściej szukane
      </Typography>

      <Chip
        icon={<StorefrontIcon sx={{ fontSize: "16px !important" }} />}
        label="Dostępne w e-commerce"
        size="small"
        clickable
        onClick={toggleEcommerceOnly}
        sx={{
          height: 26,
          fontSize: "0.75rem",
          fontWeight: 600,
          bgcolor: ecommerceOnly ? "rgba(46, 125, 50, 0.18)" : "rgba(46, 125, 50, 0.08)",
          color: "success.dark",
          border: "1px solid",
          borderColor: ecommerceOnly ? "rgba(46, 125, 50, 0.45)" : "rgba(46, 125, 50, 0.22)",
          "& .MuiChip-icon": { color: "success.main" },
          "&:hover": { bgcolor: "rgba(46, 125, 50, 0.16)" },
        }}
      />

      {popularTags.map((item) => {
        const category = item.category;
        const value = item.name;
        const active = isTagActive(category, value);

        return (
          <Chip
            key={item.id}
            label={item.name}
            size="small"
            clickable
            onClick={() => {
              toggleTag(category, value);
            }}
            color={active ? "primary" : "default"}
            variant={active ? "filled" : "outlined"}
            sx={{
              height: 26,
              fontSize: "0.75rem",
              fontWeight: active ? 600 : 500,
              borderColor: active ? undefined : "rgba(0,0,0,0.14)",
              bgcolor: active ? undefined : "rgba(0,0,0,0.02)",
            }}
          />
        );
      })}
    </Stack>
  );
};

export default PopularFilters;
